/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GUF } from "./GUF";
import { GUFFromJSON, GUFFromJSONTyped, GUFToJSON, GUFToJSONTyped } from "./GUF";

/**
 *
 * @export
 * @interface ApiGufGufsList200Response
 */
export interface ApiGufGufsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufGufsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufGufsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufGufsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GUF>}
   * @memberof ApiGufGufsList200Response
   */
  results: Array<GUF>;
}

/**
 * Check if a given object implements the ApiGufGufsList200Response interface.
 */
export function instanceOfApiGufGufsList200Response(
  value: object
): value is ApiGufGufsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufGufsList200ResponseFromJSON(json: any): ApiGufGufsList200Response {
  return ApiGufGufsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufGufsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufGufsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GUFFromJSON),
  };
}

export function ApiGufGufsList200ResponseToJSON(json: any): ApiGufGufsList200Response {
  return ApiGufGufsList200ResponseToJSONTyped(json, false);
}

export function ApiGufGufsList200ResponseToJSONTyped(
  value?: ApiGufGufsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GUFToJSON),
  };
}
